import * as yup from "yup";
import { MSG } from "../constants/MSG";

export const couponsSchema = yup.object().shape({
	tnc: yup.string().trim().required(MSG.REQUIRED_TERMS_AND_CONDITIONS),
	code: yup
		.string()
		.trim()
		.matches(/^[0-9A-Z]+$/, MSG.PROVIDE_VALID_COUPON_CODE)
		.max(8, MSG.VOUCHER_CODE_MAX_LIMIT)
		.required(MSG.REQUIRED_COUPONS_CODE),
	description: yup.string().trim().required(MSG.REQUIRED_DESCRIPTION),
	discountRadioOptions: yup.string().required(),
	restaurants: yup.array().of(yup.object()),
	discount: yup
		.string()
		.trim()
		.matches(/^[0-9]+$/, MSG.REQUIRED_VALID_DISCOUNT_AMOUNT)
		.required(MSG.REQUIRED_DISCOUNT_AMOUNT)
		.when("discountRadioOptions", {
			is: "Percentage",
			then: yup
				.string()
				.test(
					"Is greater than 100 ?",
					MSG.REQUIRED_DISCOUNT_LESS_THAN_100,
					(value) => value <= 100
				),
		})

		.test(
			"Is positive?",
			MSG.REQUIRED_DISCOUNT_GREATER_THAN_0,
			(value) => value > 0
		),

	max_discount: yup
		.string()
		.trim()
		.matches(/^[0-9]+$/, MSG.REQUIRED_VALID_MAXIMUM_DISCOUNT)
		.required(MSG.REQUIRED_MAX_DISCOUNT)
		.test(
			"Is positive?",
			MSG.REQUIRED_MAX_DISCOUNT_GREATER_THAN_0,
			(value) => value > 0
		),
	min_order: yup
		.string()
		.trim()
		.matches(/^[0-9]+$/, MSG.REQUIRED_VALID_MIN_ORDER)
		.required(MSG.REQUIRED_MIN_ORDER)
		.when("discountRadioOptions", {
			is: "Amount",
			then: yup
				.string()
				.test(
					"Is greater than discount ?",
					"Minimum order value must be greater than or equal to discount",
					(value, context) => value >= parseFloat(context.parent.discount)
				),
		})
		.test(
			"Is positive?",
			MSG.REQUIRED_MIN_ORDER_GREATER_THAN_0,
			(value) => value > 0
		),

	start_date: yup.date(),
	end_date: yup
		.date()
		.min(yup.ref("start_date"), MSG.REQUIRED_VALID_START_END_DATE),
});
